var $ = require('jquery');

$(document).ready(function() {
    $('.bleed-bg-from-next-block').parent().addClass('bleed-bg-from-next-block-parent');
})